// ------SAMPLE CALLS------

import {
  getBranch,
  getKey,
  getToken,
  getUser,
} from "../../../../Components/Helpers/Utilities/Common";
import {
  getAPICall,
  postAPICallwithFile,
  putAPICall,
  postAPICall,
  getWithParamsAPICall,
} from "../../../../Components/Helpers/API/axiosMethodCall";

//POST API -- append a new data to the db
export const createLastHospitalization = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hospitalization_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        name: data.name,
        admitted_on: data.admitted_on,
        reason: data.reason,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const editLastHospitalization = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hospitalization_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        name: data.name,
        admitted_on: data.admitted_on,
        reason: data.reason,
        hospitalization_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getHospitalization = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "hospitalization_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteHospitalization = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hospitalization_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        hospitalization_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createAllergy = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "allergy_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        name: data.name,
        type: data.type,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const editAllergy = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "allergy_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        type: data.type,
        name: data.name,
        allergy_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getAllergy = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "allergy_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteAllergy = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "allergy_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        allergy_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createDiabetes = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "diabetes_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        duration: data.duration,
        usual_fbs: data.usual_fbs,
        usual_rbs: data.usual_rbs,
        hba1c: data.hba1c,
        cbg_range: data.cbg_range,
        complications: data.complications,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const editDiabetes = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "diabetes_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        duration: data.duration,
        usual_fbs: data.usual_fbs,
        usual_rbs: data.usual_rbs,
        hba1c: data.hba1c,
        cbg_range: data.cbg_range,
        complications: data.complications,
        diabetes_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getDiabetes = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "diabetes_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteDiabetesApi = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "diabetes_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        diabetes_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createAsthma = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "asthma_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        duration: data.duration,
        last_attack: data.last_attack,
      }
    );
    return response;
  } catch (error) {
    return { error: error.response };
  }
};

export const getAsthma = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "asthma_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editAsthma = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "asthma_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        duration: data.duration,
        last_attack: data.last_attack,
        asthma_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteAsthma = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "asthma_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        asthma_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createMedication = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "medication_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        generic: data.generic || "",
        brand: data.brand || "",
        preparation: data.preparation || "",
        form: data.form || "",
        dosage: data.dosage || "",
        frequency: data.frequency || "",
        timing: data.timing || "",
        duration: data.duration || "",
        compliance: data.compliance || "",
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getMedication = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "medication_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editMedication = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "medication_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        generic: data.generic,
        brand: data.brand,
        preparation: data.preparation,
        form: data.form,
        dosage: data.dosage,
        frequency: data.frequency,
        timing: data.timing,
        duration: data.duration,
        compliance: data.compliance,
        medication_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteMedication = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "medication_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        medication_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createHypertension = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hypertension_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        duration: data.duration,
        highest_bp: data.highest_bp,
        usual_bp: data.usual_bp,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getHypertension = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "hypertension_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editHypertension = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hypertension_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        duration: data.duration,
        highest_bp: data.highest_bp,
        usual_bp: data.usual_bp,
        hypertension_profile_id: data.id,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteHypertension = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hypertension_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        hypertension_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getHerbal = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "herbal_use_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createHerbal = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "herbal_use_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        is_herbal_user: data.is_herbal_user,
        name: data.name,
        last_intake: data.last_intake,
        duration: data.duration,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const editHerbal = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "herbal_use_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_herbal_user: data.is_herbal_user,
        duration: data.duration,
        name: data.name,
        last_intake: data.last_intake,
        herbal_use_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteHerbal = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "herbal_use_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        herbal_use_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getSexualActivity = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "sexual_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createSexualActivity = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sexual_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        // is_fpe: "1",
        is_active: data.is_sexually_active,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const editSexualActivity = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sexual_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_active: data.is_sexually_active,
        sexual_activity_profile_id: data.id,
      }
    );
    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteSexualActivity = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sexual_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        sexual_activity_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getThyroid = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "thyroid_disorder_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createThyroid = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "thyroid_disorder_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        type: data.type,
        medication: data.medication,
        duration: data.duration,
        rai: data.rai,
        surgery: data.surgery,
        levothyroxine: data.levothyroxine,
        histopathologic: data.histopathologic,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const editThyroid = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "thyroid_disorder_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        type: data.type,
        medication: data.medication,
        duration: data.duration,
        rai: data.rai,
        surgery: data.surgery,
        levothyroxine: data.levothyroxine,
        histopathologic: data.histopathologic,
        thyroid_disorder_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteThyroid = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "thyroid_disorder_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        thyroid_disorder_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getPituitary = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "pituitary_disorder_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createPituitary = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pituitary_disorder_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        name: data.name,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const editPituitary = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pituitary_disorder_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        name: data.name,
        pituitary_disorder_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};
export const deletePituitary = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pituitary_disorder_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        pituitary_disorder_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getEndocrine = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "other_endocrine_disease_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createEndocrine = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_endocrine_disease_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        name: data.name,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const editEndocrine = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_endocrine_disease_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        name: data.name,
        other_endocrine_disease_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};
export const deleteEndocrine = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_endocrine_disease_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        other_endocrine_disease_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getIllness = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "other_illness_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createIllness = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_illness_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        name: data.name,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const createPastMedicalHistory = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "past_med_histories/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        diseases: Array.isArray(data.disease)
          ? data.disease
          : Array.isArray(data.name)
          ? data.name
          : data.name
          ? [data.name]
          : [],
        descriptions: Array.isArray(data.description)
          ? data.description
          : data.description
          ? [data.description]
          : [],
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getPastMedicalHistory = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "past_med_histories/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deletePastMedicalHistory = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "past_med_histories/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};




export const editIllness = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_illness_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        name: data.name,
        other_illness_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};
export const deleteIllness = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_illness_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        other_illness_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};


export const getSmoking = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "smoking_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createSmoking = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "smoking_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        is_smoker: data.is_smoker,
        duration: data.duration,
        sticks_per_day: data.sticks_per_day,
        pack_of_cigarette: data.pack_of_cigarette,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const editSmoking = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "smoking_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_smoker: data.is_smoker,
        duration: data.duration,
        sticks_per_day: data.sticks_per_day,
        pack_of_cigarette: data.pack_of_cigarette,
        smoking_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};
export const deleteSmoking = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "smoking_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        smoking_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const getDrinking = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "drinking_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createDrinking = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "drinking_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        is_drinker: data.is_drinker,
        frequency: data.frequency,
        consumption: data.consumption,
        btl_per_day: data.btl_per_day,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const editDrinking = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "drinking_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_drinker: data.is_drinker,
        frequency: data.frequency,
        consumption: data.consumption,
        btl_per_day: data.btl_per_day,
        drinking_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};
export const deleteDrinking = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "drinking_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        drinking_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createDrug = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "drug_use_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        is_drug_user: data.is_drug_user,
        name: data.name,
        last_intake: data.last_intake,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getDrug = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "drug_use_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editDrug = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "drug_use_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_drug_user: data.is_drug_user,
        name: data.name,
        last_intake: data.last_intake,
        drug_use_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteDrug = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "drug_use_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        drug_use_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createHeredofamilial = async (data, patient_id) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("patient_id", patient_id);
    formData.append("is_fpe", "1");
    data.default_diseases &&
      data.default_diseases.forEach((val) => {
        formData.append("name[]", val);
      });
    data.others &&
      data.others.split(",").forEach((val) => {
        formData.append("other[]", val);
      });

    // update basically is create
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK +
        "heredofamilial_disease_profiles/update_multiple",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
export const createHeredofamilialDetails = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK +
        "heredofamilial_disease_profiles/create_multiple",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id?.id ? patient_id.id : patient_id,
        is_fpe: "1",
        diseases: Array.isArray(data.diseases) ? data.diseases : [],
        descriptions: Array.isArray(data.descriptions)
          ? data.descriptions
          : [],
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
export const deleteHeredofamilial = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "heredofamilial_disease_profiles/delete_all",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getHeredofamilial = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
      // patient_id: patient_id.id
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "heredofamilial_disease_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
// export const deleteHeredofamilial = async (id) => {
//   try {
//     const response = await postAPICall(
//       process.env.REACT_APP_LINK + "heredofamilial_disease_profiles/delete",
//       {
//         requester: getUser(),
//         token: getToken(),
//         heredofamilial_disease_profile_id: id,
//       }
//     )
//     return { data: response }
//   } catch (error) {
//     return { error: error.response }
//   }
// }
export const createGDM = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "gdm_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        aog: data.aog,
        fasting: data.fasting,
        glucose_load_1h: data.glucose_load_1h,
        glucose_load_2h: data.glucose_load_2h,
        insulin_use: data.insulin_use,
        handout_link: data.handout_link,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getGDM = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "gdm_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editGDM = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "gdm_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        aog: data.aog,
        fasting: data.fasting,
        glucose_load_1h: data.glucose_load_1h,
        glucose_load_2h: data.glucose_load_2h,
        insulin_use: data.insulin_use,
        handout_link: data.handout_link,
        gdm_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteGDM = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "gdm_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        gdm_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const createPreGDM = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pre_gdm_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        is_fpe: "1",
        aog: data.aog,
        hba1c: data.hba1c,
        fasting: data.fasting,
        glucose_load_1h: data.glucose_load_1h,
        glucose_load_2h: data.glucose_load_2h,
        insulin_use: data.insulin_use,
        handout_link: data.handout_link,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getPreGDM = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "pre_gdm_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editPreGDM = async (data, patient_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pre_gdm_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: patient_id.id,
        aog: data.aog,
        hba1c: data.hba1c,
        fasting: data.fasting,
        glucose_load_1h: data.glucose_load_1h,
        glucose_load_2h: data.glucose_load_2h,
        insulin_use: data.insulin_use,
        handout_link: data.handout_link,
        pre_gdm_profile_id: data.id,
      }
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deletePreGDM = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pre_gdm_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        pre_gdm_profile_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

/**
 *  --- VACCINATION PROFILE
 */
export const getVaxProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "vax_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createVaxProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "vax_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        vax_shot_id: data.vax_shot_id,
        lot_number: data.lot_number || "",
        expiry_date: data.expiry_date || "",
        route_injection: data.route_injection || "",
        manufacturing_no_brand: data.manufacturing_no_brand || "",
        taken_on: data.taken_on,
        next_shot_on: data.next_shot_on || "",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};
export const editVaxProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "vax_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        vax_profile_id: data.id,
        vax_shot_id: data.vax_shot_id,
        lot_number: data.lot_number || "",
        expiry_date: data.expiry_date || "",
        route_injection: data.route_injection || "",
        manufacturing_no_brand: data.manufacturing_no_brand || "",
        taken_on: data.taken_on,
        next_shot_on: data.next_shot_on,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};
export const deleteVaxProfile = async (vax_profile_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "vax_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        vax_profile_id: vax_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getVaccinationShots = async () => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "vax_shots/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**CANCER**/
export const createCancerProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "cancer_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        organ: data.organ,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editCancerProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "cancer_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        cancer_profile_id: data.id,
        organ: data.organ,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteCancerProfile = async (cancer_profile_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "cancer_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        cancer_profile_id: cancer_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getCancerProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "cancer_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**FAMILY CANCER**/
export const createCancerFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_cancer_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        organ: data.organ,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editCancerFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_cancer_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        family_cancer_profile_id: data.id,
        organ: data.organ,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteCancerFamilyProfile = async (family_cancer_profile_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_cancer_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        family_cancer_profile_id: family_cancer_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getCancerFamilyProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "family_cancer_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**HEPATITIS**/
export const createHepatitisProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hepatitis_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        type: data.type,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editHepatitisProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hepatitis_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        hepatitis_profile_id: data.id,
        type: data.type,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteHepatitisProfile = async (hepatitis_profile_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "hepatitis_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        hepatitis_profile_id: hepatitis_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getHepatitisProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "hepatitis_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**FAMILY HEPATITIS**/
export const createHepatitisFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_hepatitis_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        type: data.type,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editHepatitisFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_hepatitis_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        family_hepatitis_profile_id: data.id,
        type: data.type,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteHepatitisFamilyProfile = async (
  family_hepatitis_profile_id
) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_hepatitis_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        family_hepatitis_profile_id: family_hepatitis_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getHepatitisFamilyProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "family_hepatitis_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**Pulmonary TB**/
export const createPulmonaryTBProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        category: data.category,
        is_extra: "0",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editPulmonaryTBProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        pulmonary_tb_profile_id: data.id,
        category: data.category,
        is_extra: "0",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deletePulmonaryTBProfile = async (pulmonary_tb_profile_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        pulmonary_tb_profile_id: pulmonary_tb_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getPulmonaryTBProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**Family Pulmonary TB**/
export const createPulmonaryTBFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        category: data.category,
        is_extra: "0",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editPulmonaryTBFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        family_pulmonary_tb_profile_id: data.id,
        category: data.category,
        is_extra: "0",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deletePulmonaryTBFamilyProfile = async (
  family_pulmonary_tb_profile_id
) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        family_pulmonary_tb_profile_id: family_pulmonary_tb_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getPulmonaryTBFamilyProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**Family Extrapulmonary TB**/
export const createExtrapulmonaryTBProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        category: data.category,
        is_extra: "1",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editExtrapulmonaryTBProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        pulmonary_tb_profile_id: data.id,
        category: data.category,
        is_extra: "1",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteExtrapulmonaryTBProfile = async (
  pulmonary_tb_profile_id
) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        pulmonary_tb_profile_id: pulmonary_tb_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getExtrapulmonaryTBProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "pulmonary_tb_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**Family Extrapulmonary TB**/
export const createExtrapulmonaryTBFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        category: data.category,
        is_extra: "1",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editExtrapulmonaryTBFamilyProfile = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        family_pulmonary_tb_profile_id: data.id,
        category: data.category,
        is_extra: "1",
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteExtrapulmonaryTBFamilyProfile = async (
  family_pulmonary_tb_profile_id
) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        family_pulmonary_tb_profile_id: family_pulmonary_tb_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getExtrapulmonaryTBFamilyProfile = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "family_pulmonary_tb_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createAddObgyneHistory = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "ob_profiles/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        is_fpe: "1",
        is_sexually_active: data.is_sexually_active,
        has_family_planning: data.has_family_planning,
        menarche: data.menarche,
        period_duration: data.period_duration,
        gravidity: data.gravidity,
        delivery_type: data.delivery_type,
        parity: data.parity,
        menopause_age: data.menopause_age,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editObgyneHistory = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "ob_profiles/edit",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        ob_profile_id: data.id,
        is_sexually_active: data.is_sexually_active,
        has_family_planning: data.has_family_planning,
        menarche: data.menarche,
        period_duration: data.period_duration,
        gravidity: data.gravidity,
        delivery_type: data.delivery_type,
        parity: data.parity,
        menopause_age: data.menopause_age,
      }
    );

    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteObgyneHistory = async (ob_profile_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "ob_profiles/delete",
      {
        requester: getUser(),
        token: getToken(),
        ob_profile_id: ob_profile_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getObgyneHistory = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "ob_profiles/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getYakapImmunization = async (type) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      yakap_immunization_type: type,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "immunizations/get_yakap_immunization",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createImmunization = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "immunizations/create",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        assessment_id: data.assessment_id || "",
        child_imm_code: data.child_imm_code || "",
        youngw_imm_code: data.youngw_imm_code || "",
        pregw_imm_code: data.pregw_imm_code || "",
        elderly_imm_code: data.elderly_imm_code || "",
        other_imm: data.other_imm || "",
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const editImmunization = async (data, id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "immunizations/update",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id.id,
        immunization_id: data.id,
        assessment_id: data.assessment_id || "",
        child_imm_code: data.child_imm_code || "",
        youngw_imm_code: data.youngw_imm_code || "",
        pregw_imm_code: data.pregw_imm_code || "",
        elderly_imm_code: data.elderly_imm_code || "",
        other_imm: data.other_imm || "",
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const deleteImmunization = async (immunization_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "immunizations/delete",
      {
        requester: getUser(),
        token: getToken(),
        immunization_id: immunization_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { data: error.response.data };
  }
};

export const getImmunization = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "immunizations/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};